import React, { useEffect, useState, useCallback } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { searchAtom } from '../../recoil/atom/SearchAtom'
import { apiInstance } from 'configuration/axios'
import { mediaContent } from 'interface'
import { DebounceInput } from 'react-debounce-input'
import 'react-loading-skeleton/dist/skeleton.css'
import Skeleton from 'react-loading-skeleton'
import { getSearchCategory, getPageFromTableName } from '../../utils'
import searchSuggestions from 'assets/data/search_auto_complete.json'
// import Skeleton from 'react-loading-skeleton'
// import 'react-loading-skeleton/dist/skeleton.css'

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

const searchResult = () => {
  const searchCategory = getSearchCategory()
  const { t } = useTranslation()
  const [searchValue, setSearch] = useRecoilState(searchAtom)
  const { page } = useParams()
  const query = useQuery()
  const keyword = query.get('keyword')
  const category = query.get('category')
  const regex = /(<([^>]+)>)/gi
  const [content, setContent] = useState<mediaContent[]>([])
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(true)
  const [sortBy, setSortBy] = useState<string>('last')
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false)
  const [suggestWord, setSuggestWord] = useState<string[]>([])
  const [pageData, setPageData] = useState({
    last: 0,
    offset: 0,
    page: 1,
    per_page: 15,
    total_rows: 0,
  })
  useEffect(() => {
    window.scrollTo(0, 0)
    setSearch({ keyword: keyword, category: category })
    setLoading(true)
    if (content.length > 0) setContent([])
    let query = `search?category=${category}&page=${pageData.page}&sort=${sortBy}&limit=${pageData.per_page}`
    if (keyword) query += `&q=${keyword}`

    apiInstance
      .get(query)
      .then(res => {
        if (res.data?.data) {
          setContent(res.data.data)
          setPageData(res.data.pagination)
        }

        setLoading(false)
      })
      .catch(err => {
        console.error(err)
      })
  }, [page, pageData.page, sortBy, category, keyword])

  const onChangePage = (event: any, page: number) => {
    event.preventDefault()
    window.scrollTo(0, 0)
    setPageData({ ...pageData, page: page })
  }

  const handleSortContent = (event: any) => {
    setSortBy(event.target.value)
  }

  const handleSelectSuggestion = (event: any) => {
    const val = event.target.innerText
    setSearch(prev => {
      return { ...prev, keyword: val }
    })
    setIsOpenSuggestion(false)
  }

  const handleChange = (e: any) => {
    // console.log('searchState',_)
    setSearch(prev => {
      return { ...prev, category: e.target.value }
    })
  }
  const handleSearch = (event: any) => {
    event.preventDefault()
    if (searchValue.category !== '')
      navigate(`/search?keyword=${searchValue.keyword}&category=${searchValue.category}`)
    else console.log('searchValue', searchValue)
    return
  }

  const handleInputKeyword = useCallback(
    (e: any) => {
      setSearch(prev => {
        return { ...prev, keyword: e.target.value }
      })
      setIsOpenSuggestion(true)
    },
    [setSearch]
  )

  useEffect(() => {
    if (searchValue?.keyword && searchValue.keyword?.length > 0) {
      const suggest = searchSuggestions
        .filter(e => e.includes(searchValue.keyword ?? ''))
        .slice(0, 6)
      setSuggestWord(suggest)
    } else {
      setIsOpenSuggestion(false)
    }
  }, [searchValue.keyword])

  return (
    <div> 
      {/* <Helmet>
        <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v14.0&appId=367801984327528&autoLogAppEvents=1" nonce="C6cAcI1e"></script>
            </Helmet> */}
      <section className="update-breadcrumb">
        <div className="auto-container">
          <div className="sec-title">
            <div className="clearfix">
              <ul className="cbreadcrumb">
                <li>
                  <Link to="/">หน้าหลัก</Link>
                </li>
                <li>ผลลัพธ์การค้นหา</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="search-keyword-type2">
        <div className="auto-container">
          <div className="newsletter-form">
            <form onSubmit={handleSearch} action="">
              <div className="row">
                <div className="col-12 col-lg-7 col-md-5 col-sm-5">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="กรุณาพิมพ์คำที่ต้องการ เช่น ยาสมุนไพร, ผิวขาว..."
                      value={searchValue.keyword ?? ''}
                      onChange={handleInputKeyword}
                    />
                    {isOpenSuggestion && suggestWord.length > 0 && (
                      <div className="suggestionSearch  suggestionSearch-innerPage">
                        <ul>
                          {suggestWord.map((item, index) => (
                            <li onClick={handleSelectSuggestion} key={`suggestion${index}`}>
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                  <div className="form-group">
                    <select
                      className="legSelect"
                      name="option"
                      id=""
                      defaultValue={category ?? ''}
                      onChange={handleChange}>
                      <option value="all">ตัวช่วยการค้นหา (ทั้งหมด) </option>
                      {searchCategory.map(e => (
                        <option key={e.key} value={e.key}>
                          {t(`menu.${e.key}`)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-12 col-lg-2 col-md-4 col-sm-4">
                  <a
                    href="search-result-style-2.php"
                    onClick={handleSearch}
                    className="theme-btn btn-style-three h-45 w-100 text-center">
                    <span className="txt">
                      <span className="icon fa fa-search mr-2"></span> ค้นหา
                    </span>
                  </a>
                </div>
              </div>
            </form>
            <div className="display_result mt-4">
              <div className="row">
                <div className="col-12 col-lg-10 col-md-8 col-sm-8">
                  {!loading && (
                    <p className="fs-36">
                      ค้นหาพบ {pageData.total_rows.toLocaleString('en-US')} รายการ
                    </p>
                  )}
                  {loading && (
                    <div>
                      <Skeleton count={1} />
                    </div>
                  )}
                </div>
                <div className="col-12 col-lg-2 col-md-4 col-sm-4">
                  <select className="legSelect" name="option" id="" onChange={handleSortContent}>
                    <option value="last">ล่าสุด</option>
                    <option value="popular">ยอดนิยม</option>
                  </select>
                </div>
              </div>

              {loading && (
                <div>
                  <div>
                    <Skeleton count={1} />
                  </div>
                  <div style={{ marginTop: '15px' }}>
                    <Skeleton count={1} />
                  </div>
                  <div style={{ marginTop: '15px' }}>
                    <Skeleton count={5} />
                  </div>
                  <div style={{ marginTop: '15px', textAlign: 'right' }}>
                    <Skeleton count={1} style={{ width: 200 }} />
                  </div>
                </div>
              )}
              {content.length > 0 &&
                content.map((item, index) => (
                  <div key={`searchResult${index}`} className="row">
                    <div className="col-12">
                      <Link
                        to={`/media/${getPageFromTableName(item._table_name)}/${item._table_name}/${
                          item.id
                        }?ref=search`}>
                        <h5 className="mb-3">{item.title}</h5>
                      </Link>
                      <span className="fa fa-calendar mb-2"></span> {item.publishDate}
                      <p
                        className="mb-3 mt-2 newsp"
                        style={{ overflow: 'hidden', height: 60 }}
                        dangerouslySetInnerHTML={{
                          __html: item.shortDescription.replace(regex, ''),
                        }}></p>
                      <div>
                        <span className="badge badge-primary">
                          {t(`menu.${getPageFromTableName(item._table_name)}`)}
                        </span>
                      </div>
                      <div className="pull-right">
                        <Link
                          to={`/media/${getPageFromTableName(item._table_name)}/${
                            item._table_name
                          }/${item.id}?ref=search`}
                          className="theme-btn btn-style-show_all text-center">
                          <span className="txt">อ่านต่อ</span>
                        </Link>
                      </div>
                    </div>
                    <hr className="hr_custom_gray" />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <section className="mb-5">
        <div className="auto-container">
          <div className="styled-pagination text-center">
            <ul className="clearfix">
              {pageData.page - 1 > 0 && (
                <li className="prev">
                  <a href="#" onClick={e => onChangePage(e, pageData.page - 1)}>
                    <span className="fa fa-angle-left"></span>{' '}
                  </a>
                </li>
              )}
              {pageData.page - 1 > 0 && (
                <li>
                  <a href="#" onClick={e => onChangePage(e, pageData.page - 1)}>
                    {pageData.page - 1}
                  </a>
                </li>
              )}
              <li className="active">
                <a href="#" onClick={e => e.preventDefault()}>
                  {pageData.page}
                </a>
              </li>
              {pageData.page + 1 <= pageData.last && (
                <li>
                  <a href="#" onClick={e => onChangePage(e, pageData.page + 1)}>
                    {pageData.page + 1}
                  </a>
                </li>
              )}
              {pageData.page == 1 && pageData.page + 2 <= pageData.last && (
                <li>
                  <a href="#" onClick={e => onChangePage(e, pageData.page + 2)}>
                    {pageData.page + 2}
                  </a>
                </li>
              )}
              {pageData.page + 1 <= pageData.last && (
                <li className="next">
                  <a href="#" onClick={e => onChangePage(e, pageData.page + 1)}>
                    <span className="fa fa-angle-right"></span>{' '}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}

export default searchResult
